const faqQuestions = {
  EN: [
    'Can I take company books home?',
    'How do I submit receipts for commuter passes, petty cash transportation expenses, and similar expenses?',
    'What conditions and preparations are required for remote work?',
    'How should I apply if I want to telework?',
    'Where can I check which software is available?',
    'What should I do when I am the last person leaving the office during normal work?',
    'Can I use personal Bluetooth devices such as earphones?',
    'How can I receive a position allowance, and how much is paid?',
    'What should I do if I lose my smartphone or otherwise need to change Salesforce MFA authentication?',
    'In Salesforce work records, which task should I use for monthly kickoff meetings or department meetings?',
  ],
  '日本語': [
    '会社の本を持ち帰ることはできますか？',
    '小口交通費など、定期券の領収書の提出方法は？',
    'リモートワークをするにはどういう条件と準備が必要ですか？',
    'テレワークしたい場合はどのように申請した方がいいですか？',
    '利用可能なソフトウェアはどこで確認できますか？',
    '普段業務で最終退出時は何をしたら良いですか？',
    '私物のイヤホンなどのBluetooth機器を使っても良いですか？',
    '役職手当はどうしたらもらえますか？どれくらい支給されます？',
    'スマホなくしたなど、SalesforceのMFA認証を変更したい場合はどうしますか？',
    'Salesforceの工数実績で、月初会議や課会議は、どのタスクになりますか？',
  ],
};

export default faqQuestions;